import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Form, InputGroup, ListGroup, Badge, Accordion } from 'react-bootstrap';
import Layout from '../../components/Layout';
import axios from 'axios';
import { getCookie } from '../../helpers/helpers';
import { FaWhatsapp, FaRegCopy } from 'react-icons/fa';

const Invocing = () => {
    const [data, setData] = useState([]);
    const [invoices, setInvoices] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');

    const fetchData = () => {
        axios.post(`${process.env.REACT_APP_API}/invoicing/read`, { token: getCookie('token') })
            .then(response => {
                setData(response.data.partner);
                setInvoices(response.data.invoice || []);
            })
            .catch(error => {
                console.error('Error fetching invoicing data:', error);
            });
    };

    useEffect(() => {
        fetchData();
    }, []);

    const activeUsers = data.filter(user => user.membership_type !== 'free').length;
    const trialUsers = data.filter(user => user.membership_type === 'free' && new Date(user.trial_end) > new Date()).length;
    const totalUsers = data.length;

    const recentRegistrations = [...data].sort((a, b) => new Date(b.registration_date) - new Date(a.registration_date)).slice(0, 5);
    const trialUsersData = data.filter(user => user.membership_type === 'free' && new Date(user.trial_end) > new Date());
    
    const lastTrialsData = data.filter(user => {
        const trialEnd = new Date(user.trial_end);
        const now = new Date();
        const tenDaysAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 10);
        return trialEnd < now && trialEnd > tenDaysAgo;
    });

    const subscriptionUsersData = data
        .filter(user => user.membership_type !== 'free')
        .map(user => {
            const userInvoices = invoices.filter(inv => inv.partner_id && inv.partner_id[0] === user.id);
            const lastInvoice = userInvoices.sort((a, b) => new Date(b.invoice_date) - new Date(a.invoice_date))[0];
            const daysSinceLastInvoice = lastInvoice && lastInvoice.invoice_date ? Math.max(1, Math.floor((new Date() - new Date(lastInvoice.invoice_date)) / (1000 * 60 * 60 * 24))) : null;
            return {
                ...user,
                invoiceCount: userInvoices.length,
                lastInvoice: lastInvoice,
                daysSinceLastInvoice: daysSinceLastInvoice
            };
        })
        .sort((a, b) => {
            if (a.invoiceCount === 0 && b.invoiceCount > 0) return -1;
            if (a.invoiceCount > 0 && b.invoiceCount === 0) return 1;
            if (a.daysSinceLastInvoice === null && b.daysSinceLastInvoice !== null) return -1;
            if (a.daysSinceLastInvoice !== null && b.daysSinceLastInvoice === null) return 1;
            return b.daysSinceLastInvoice - a.daysSinceLastInvoice;
        });

    const formatPhoneNumberForWhatsapp = (phone) => {
        if (!phone) return '';
        let phoneNumber = phone.startsWith('0') ? phone.substring(1) : phone;
        phoneNumber = phoneNumber.startsWith('+421') ? phoneNumber.substring(4) : phoneNumber;
        return `https://wa.me/421${phoneNumber}`;
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
    };

    const addTrialDays = (user, days) => {
        const newTrialEnd = new Date();
        newTrialEnd.setDate(newTrialEnd.getDate() + days);
        const updatedUser = { ...user, trial_end: newTrialEnd.toISOString(), membership_type: 'free' };
        
        axios.post(`${process.env.REACT_APP_API}/invoicing/update`, { user: updatedUser, token: getCookie('token') })
            .then(() => {
                fetchData(); // Refresh data after update
            })
            .catch(error => {
                console.error('Error updating user trial:', error);
            });
    };

    const deactivateSubscription = (user) => {
        const updatedUser = { ...user, membership_type: 'free' };
        
        axios.post(`${process.env.REACT_APP_API}/invoicing/update`, { user: updatedUser, token: getCookie('token') })
            .then(() => {
                fetchData(); // Refresh data after update
            })
            .catch(error => {
                console.error('Error deactivating subscription:', error);
            });
    };

    const getRemainingTrialDays = (trialEnd) => {
        const remaining = new Date(trialEnd) - new Date();
        return Math.ceil(remaining / (1000 * 60 * 60 * 24));
    };

    const filteredUsers = data.filter(user =>
        (user.name && user.name.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (user.email && user.email.toLowerCase().includes(searchQuery.toLowerCase()))
    );

    const renderUserActions = (user) => (
        <div className="d-flex align-items-center flex-wrap">
            {user.phone && (
                <div className="d-flex align-items-center me-2 mb-2 mb-md-0">
                    <a href={formatPhoneNumberForWhatsapp(user.phone)} target="_blank" rel="noopener noreferrer" className="me-2">
                        <FaWhatsapp size={20} />
                    </a>
                    <Button variant="link" size="sm" onClick={() => copyToClipboard(user.phone)}>
                        <FaRegCopy size={20} />
                    </Button>
                </div>
            )}
            <div className="d-flex align-items-center">
                <Button variant="outline-primary" size="sm" className="me-1" onClick={() => addTrialDays(user, 3)}>+3 dni</Button>
                <Button variant="outline-primary" size="sm" className="me-1" onClick={() => addTrialDays(user, 5)}>+5 dní</Button>
                <Button variant="outline-primary" size="sm" className="me-1" onClick={() => addTrialDays(user, 7)}>+7 dní</Button>
                <Button variant="outline-primary" size="sm" onClick={() => addTrialDays(user, 30)}>+30 dní</Button>

            </div>
        </div>
    );

    return (
        <Layout>
            <Container fluid>
                <Row className="my-4">
                    <Col>
                        <Card>
                            <Card.Body>
                                <Card.Title>Súhrn používateľov</Card.Title>
                                <Row className="text-center">
                                    <Col xs={12} md={4}>
                                        <h5>Aktívni používatelia</h5>
                                        <p className="h3">{activeUsers}</p>
                                    </Col>
                                    <Col xs={12} md={4}>
                                        <h5>Používatelia na skúšku</h5>
                                        <p className="h3">{trialUsers}</p>
                                    </Col>
                                    <Col xs={12} md={4}>
                                        <h5>Celkovo registrovaní</h5>
                                        <p className="h3">{totalUsers}</p>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="my-4">
                    <Col>
                        <Card>
                            <Card.Body>
                                <Card.Title>Vyhľadať používateľa</Card.Title>
                                <InputGroup className="mb-3">
                                    <Form.Control
                                        placeholder="Hľadať podľa mena alebo emailu"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </InputGroup>
                                {searchQuery && (
                                    <ListGroup>
                                        {filteredUsers.map(user => (
                                            <ListGroup.Item key={user.id} className="d-flex justify-content-between align-items-center flex-column flex-md-row">
                                                <div className="mb-2 mb-md-0">
                                                    <div>{user.name} ({user.email})</div>
                                                </div>
                                                {renderUserActions(user)}
                                            </ListGroup.Item>
                                        ))}
                                    </ListGroup>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="my-4">
                    <Col>
                        <Card>
                            <Card.Body>
                                <Card.Title>Posledné registrácie</Card.Title>
                                <ListGroup>
                                    {recentRegistrations.map(user => (
                                        <ListGroup.Item key={user.id} className="d-flex justify-content-between align-items-center flex-column flex-md-row">
                                            <div className="mb-2 mb-md-0">{user.name} - {user.email}</div>
                                            {renderUserActions(user)}
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                
                <Row className="my-4">
                    <Col>
                        <Card>
                            <Card.Body>
                                <Card.Title>Posledné trialy</Card.Title>
                                <ListGroup>
                                    {lastTrialsData.map(user => (
                                        <ListGroup.Item key={user.id}>
                                            {user.name} - {user.email} (skončil {new Date(user.trial_end).toLocaleDateString()})
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="my-4">
                    <Col>
                        <Card>
                            <Card.Body>
                                <Card.Title>Používatelia na skúšku</Card.Title>
                                <ListGroup>
                                    {trialUsersData.map(user => (
                                        <ListGroup.Item key={user.id} className="d-flex justify-content-between align-items-center">
                                            <div>
                                                {user.name} <Badge bg="secondary">{getRemainingTrialDays(user.trial_end)} dní</Badge>
                                            </div>
                                            <div>
                                                {user.phone && (
                                                    <>
                                                        <a href={formatPhoneNumberForWhatsapp(user.phone)} target="_blank" rel="noopener noreferrer" className="me-2">
                                                            <FaWhatsapp size={20} />
                                                        </a>
                                                        <Button variant="link" size="sm" onClick={() => copyToClipboard(user.phone)}>
                                                            <FaRegCopy size={20} />
                                                        </Button>
                                                    </>
                                                )}
                                            </div>
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="my-4">
                    <Col>
                        <Card>
                            <Card.Body>
                                <Card.Title>Používatelia s predplatným</Card.Title>
                                <Accordion>
                                    {subscriptionUsersData.map((user, index) => (
                                        <Accordion.Item eventKey={index.toString()} key={user.id}>
                                            <Accordion.Header>
                                                <span>{user.name}</span>
                                                {user.daysSinceLastInvoice !== null && (
                                                    <Badge 
                                                        bg={user.daysSinceLastInvoice > 32 ? 'danger' : user.daysSinceLastInvoice > 30 ? 'warning' : 'success'}
                                                        className="ms-2"
                                                    >
                                                        {user.daysSinceLastInvoice}
                                                    </Badge>
                                                )}
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <p>Email: {user.email}</p>
                                                <p>Počet faktúr: {user.invoiceCount}</p>
                                                {user.lastInvoice && (
                                                    <p>Posledná faktúra: {user.lastInvoice.amount_total_signed} €</p>
                                                )}
                                                <Button variant="danger" onClick={() => deactivateSubscription(user)}>Vypnúť</Button>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    ))}
                                </Accordion>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Layout>
    );
};

export default Invocing;
